import stringifyObject from 'stringify-object';
import { CodeLanguages } from '../code';

const codeParams = (language, endpoint, params) => {
  const code = {
    python: `# pip install fetchfox-sdk

from fetchfox_sdk import FetchFox

fox = FetchFox(api_key="YOUR_API_KEY")

data = fox.${endpoint}(${JSON.stringify(params, null, 2)})`,

    javascript: `// npm install fetchfox-sdk

import * as fox from 'fetchfox-sdk';

fox.configure({ apiKey: 'YOUR_API_KEY' });

const data = await fox.${endpoint}(${stringifyObject(params, { indent: '  ' })});`,

    mcp: `{
  "url": "https://mcp.fetchfox.ai/mcp",
  "transport": {
    "type": "http",
    "headers": {
      "Authorization": "Bearer YOUR_API_KEY"
    }
}

# And then ask your agent to scrape something`,

    pydantic: `from pydantic_ai import Agent
from pydantic_ai.mcp import MCPServerStreamableHTTP

fetchfox = MCPServerStreamableHTTP(
    url='https://mcp.fetchfox.ai/mcp',
    headers={"Authorization": "Bearer YOUR_API_KEY"})

agent = Agent('openai:gpt-4o', toolsets=[fetchfox])
result = agent.run_sync(
  'Scrape username, text, and points from '
  'https://www.reddit.com/r/*/comments/*')`,

    bash: `curl -X POST https://api.fetchfox.ai/api/${endpoint} \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $FETCHFOX_API_KEY" \\
  -d '${JSON.stringify(params, null, 2)}'`,

    json: JSON.stringify(params, null, 2),
  }[language];

  return code;
};

export const Code = ({ endpoint, params }) => {
  const snippets = [
    { name: 'JavaScript', language: 'javascript', code: codeParams('javascript', endpoint, params) },
    { name: 'Python', language: 'python', code: codeParams('python', endpoint, params) },
    { name: 'curl', language: 'bash', code: codeParams('bash', endpoint, params) },
    { name: 'JSON', language: 'json', code: codeParams('json', endpoint, params) },
  ];

  return <CodeLanguages snippets={snippets} />;
};
